import get from "lodash/get";
import { clearBrandFollowCache } from "@/components/product/brandFollowCache";
import { deleteWebApi, fetchWebApi } from "../../webapis/apiResource";
import {
  SESSION_TERMINATED,
  STORE_TOKEN,
  LOGOUT_SUCCESS,
  SAVE_USER_DETAILS,
  SET_ADDRESS_BOOK,
  SET_DEFAULT_ADDRESS,
  SHOW_PREVIEW,
  SET_PREV_PATH,
  STORE_TOKEN_CHECKOUT_GUEST,
  RESET_TOKEN_CHECKOUT_GUEST,
  SET_EMAIL,
  SET_AUTH_DATA,
  SET_EMAIL_OTP_DATA,
  CLEAR_EMAIL_OTP_DATA,
  SAVE_UPDATE_DETAILS_DATA,
  RESET_UPDATE_DETAILS_DATA,
  RESET_AUTH_DATA,
  SET_TURNSTILE_CAPTCHA_TOKEN
} from "../constants";
import { getAccessToken } from "../../util/storeHelper";
import { BEConfig } from "../../config/env";
import { handleFetchError } from "../../util/errorHandler";
import { emptyWishListAndCart } from "./wishlist.action";
import {
  removeUserStorage,
  setUserEmailStorage,
  removeUserEmailStorage,
  removeGuestUserStorage,
  setUserStorage
} from "../../util/browserStorage";
import {
  showLoadingIndicator,
  hideLoadingIndicator,
  setCountryListData,
  setLoyaltyPoints,
  resetUserOriginCountry
} from "./common.action";
import { ApiError, resetAPIError, userProfile } from "./homepage.action";
import { clearCartAndWishlistGeneralData } from "./cart.action";
import { resetCardList } from "./checkout.action";
import { clearTrackOrder, resetLoyaltyProgramInfo } from "./myAccount.action";
import AnalyticService from "../../services/analytic-service";
import { HeapService } from "../../services/analytics/heap";
import {
  filterAddressByState,
  getVisitorId,
  removeEComSessionId,
  updateVisitorId
} from "../../util/index";
import { checkIsUserPhoneDeactivated } from "../../util/user";
import { StorageService, UserDetailsService } from "../../services";
import { toastMsg } from "@/util/toast";
import { postDashboardWebApi } from "../../webapis/apiResource";
import { languageFromPathName } from "../../util";

export const setToken = ({
  accessToken,
  token = accessToken,
  redirect = true
}) => {
  return dispatch => {
    dispatch(tokenGenerator(token));
    removeGuestUserStorage();
    setUserStorage(token);
  };
};

export const setUserInfo = ({ userProfile }) => ({
  type: SAVE_USER_DETAILS,
  userProfile
});

export const setAuthUserData = data => ({
  type: SET_AUTH_DATA,
  payload: data
});

export const setUserAddressBook = addressBook => ({
  type: SET_ADDRESS_BOOK,
  addressBook
});

export const setDefaultAddress = (name, value, index) => ({
  type: SET_DEFAULT_ADDRESS,
  name,
  value,
  index
});

export const saveResponseUpdateDetailsData = data => ({
  type: SAVE_UPDATE_DETAILS_DATA,
  payload: data
});

export const resetResponseUpdateDetailsData = data => ({
  type: RESET_UPDATE_DETAILS_DATA
});

export const setPrevPath = prevPath => ({ type: SET_PREV_PATH, prevPath });

export const setEmailOtpData = payload => ({
  type: SET_EMAIL_OTP_DATA,
  payload
});

export const clearEmailOtpData = () => ({ type: CLEAR_EMAIL_OTP_DATA });

export const resetAuthData = () => ({ type: RESET_AUTH_DATA });

export const sendLoginOtp =
  ({ token, channel = "email" }) =>
  async (dispatch, getState) => {
    const otpPath = BEConfig?.customerApi?.otpSend;
    const apiURL = `${BEConfig.customerApi.protocol}${BEConfig.customerApi.baseURL}${BEConfig.customerApi.port}${BEConfig.customerApi.versionInfo}${otpPath}`;

    dispatch(showLoadingIndicator());
    try {
      const resp = await postDashboardWebApi(_, apiURL, { token, channel });
      const success = Boolean(resp?.data?.success);
      const emailOtpToken = resp?.data?.token;
      const retryAfterSeconds = resp?.data?.retryAfterSeconds;
      const maskedPhoneNumber = resp?.data?.maskedPhoneNumber;

      if (success && emailOtpToken) {
        dispatch(
          setEmailOtpData({
            emailOtpToken,
            emailOtpRetryAfterSeconds: retryAfterSeconds,
            emailOtpMaskedPhone: maskedPhoneNumber
          })
        );
      }

      return {
        success,
        retryAfterSeconds,
        emailOtpToken,
        message: resp?.data?.message
      };
    } catch (error) {
      handleFetchError(error, dispatch);
      return {
        success: false,
        retryAfterSeconds: 0,
        emailOtpToken: undefined,
        message: error?.response?.data?.message || ""
      };
    } finally {
      dispatch(hideLoadingIndicator());
    }
  };

export const fetchAddressBook = countryId => {
  const {
    customerApi: { baseURL, protocol, port, versionInfo, addressHandle }
  } = BEConfig;
  const apiURL = `${protocol}${baseURL}${port}${versionInfo}${addressHandle}?nationality=${countryId}`;
  return (dispatch, getState) => {
    return fetchWebApi(getAccessToken(getState), apiURL)
      .then(response => {
        const addressDetails = get(response, "data.addressDetails");
        if (
          response.status === 200 &&
          response.data.success &&
          addressDetails
        ) {
          const reduxStore = getState();
          const state = get(reduxStore, "common.settings.state");
          const isUserLoggedIn = get(reduxStore, "authReducer.userLoggedIn");
          isUserLoggedIn && dispatch(setUserAddressBook(addressDetails));
        } else {
          if (response.data.success === false) {
            dispatch(setUserAddressBook());
          }
          if (response.status === 401) {
            dispatch(logOut());
          }
        }
        return response;
      })
      .catch(error => {
        handleFetchError(error, dispatch);
        return error.response;
      });
  };
};
export const deleteAddress = addressId => {
  const apiURL = `${BEConfig.customerApi.protocol}${BEConfig.customerApi.baseURL}${BEConfig.customerApi.port}${BEConfig.customerApi.versionInfo}${BEConfig.customerApi.addressHandle}/${addressId}`;
  return (dispatch, getState) => {
    const reducerState = getState();
    const countryId = reducerState.common.settings.countryId;
    return deleteWebApi(getAccessToken(getState), apiURL, getVisitorId())
      .then(response => {
        if (response.status === 200 && response.data.success) {
          dispatch(fetchAddressBook(countryId));
        } else {
          toastMsg("error", response.data.message);
        }
        return response;
      })
      .catch(error => {
        handleFetchError(error, dispatch);
        return error.response;
      });
  };
};
export const fetchUserAndLoadData = ({ keepDeliverySettings } = {}) => {
  const {
    customerApi: { baseURL, protocol, port, versionInfo, userHandle }
  } = BEConfig;
  const apiURL = `${protocol}${baseURL}${port}${versionInfo}${userHandle}`;
  return (dispatch, getState) => {
    dispatch(showLoadingIndicator());
    const reducerState = getState();
    const countryId = reducerState.common.settings.countryId;
    const token = getAccessToken(getState);
    return fetchWebApi(token, apiURL)
      .then(async response => {
        const userShouldBeLoggedOut =
          (token && !response.data.success) ||
          checkIsUserPhoneDeactivated(response.data);
        const dataFetchingAllowed =
          response.status === 200 &&
          response.data.success &&
          !userShouldBeLoggedOut;

        if (dataFetchingAllowed) {
          !keepDeliverySettings && dispatch(setCountryListData([]));
          await dispatch(setUserInfo(response.data));
          const email = response.data?.userProfile?.email;
          email && setUserEmailStorage(email);
          await dispatch(fetchAddressBook(countryId));
        } else if (response.status === 401 || userShouldBeLoggedOut) {
          dispatch(logOut());
        }
        return response;
      })
      .catch(error => {
        handleFetchError(error, dispatch);
        return error.response;
      })
      .finally(() => {
        dispatch(hideLoadingIndicator());
      });
  };
};

export const logOut = doNotTrackPrevHistory => {
  AnalyticService.auth.trackLogout();
  HeapService.resetIdentity();
  removeUserStorage(document.domain);
  removeUserEmailStorage();
  removeEComSessionId();
  StorageService.removeOrdersHistoryFrom();
  updateVisitorId();
  return dispatch => {
    dispatch(logOutUser());
    dispatch(emptyWishListAndCart());
    dispatch(clearCartAndWishlistGeneralData());
    dispatch(resetLoyaltyProgramInfo());
    dispatch(resetCardList());
    dispatch(setLoyaltyPoints(null));
    !doNotTrackPrevHistory && dispatch(setPrevPath(window.location.pathname));
    dispatch(setCountryListData([]));
    dispatch(resetUserOriginCountry());
    dispatch(clearTrackOrder());
    dispatch(resetAPIError());
  };
};

export const tokenGenerator = token => ({ type: STORE_TOKEN, token });
export const tokenGeneratorCheckoutGuest = token => ({
  type: STORE_TOKEN_CHECKOUT_GUEST,
  token
});
export const resetTokenGeneratorCheckoutGuest = () => ({
  type: RESET_TOKEN_CHECKOUT_GUEST
});
export const showPrevMode = value => ({ type: SHOW_PREVIEW, value });

export const terminateSession = () => ({ type: SESSION_TERMINATED });

export const logOutUser = () => {
  clearBrandFollowCache();
  return { type: LOGOUT_SUCCESS };
};

export const setEmail = email => ({ type: SET_EMAIL, payload: email });

export const updateAuthData = (email, password) => {
  return async dispatch => {
    try {
      const response = await UserDetailsService.getUserAuthData(
        email,
        password
      );
      if (response.status === 200 && response.data && response.data.success) {
        dispatch(userProfile(response.data));
        dispatch(setToken(response.data));
      } else {
        dispatch(ApiError(response.data));
      }
      return response;
    } catch (error) {
      handleFetchError(error, dispatch);
      return error.message;
    }
  };
};

export const setTurnstileCaptchaToken = token => ({
  type: SET_TURNSTILE_CAPTCHA_TOKEN,
  payload: token
});
